import "./../../assets/css/TicketModal.scss";
import React, { useState } from "react";
import ReactDOM from "react-dom";

const TicketModal = ({ isOpen, onClose }) => {
  const [activeCouponTicket, setActiveCouponTicket] = useState(null);
  const [couponValue, setCouponValue] = useState("");
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const ROTARACT_COUPON = "SMARTCITY"; // 🔥 Change this to your real coupon

  const ticketData = [
    { id: 1, label: "Single Entry", price: 349, link: "https://rzp.io/rzp/VQGyyJx" },
    { id: 2, label: "Single Entry + 1 Thandai", price: 399, link: "https://rzp.io/rzp/yCSyig0" },
    { id: 3, label: "Couple Entry", price: 599, link: "https://rzp.io/rzp/9Bvbkha" },
    { id: 4, label: "Couple Entry + 1 Thandai", price: 699, link: "https://rzp.io/rzp/vNxtJHU3" },
    { id: 5, label: "Group 5 + 5 Drinks", price: 2499, link: "https://rzp.io/rzp/50ADpajM" },
    { id: 6, label: "Group 8 + 8 Drinks", price: 3999, link: "https://rzp.io/rzp/UpuWaL3" },
    // { id: 7, label: "Rotaract Family", price: 299, link: "https://rzp.io/rzp/aXNC7c50", isCoupon: true },
  ];

  const handleCouponSubmit = (link) => {
    if (couponValue.trim().toUpperCase() === ROTARACT_COUPON) {
      window.open(link, "_blank");
      setActiveCouponTicket(null);
      setCouponValue("");
      setError("");
    } else {
      setError("Invalid Coupon Code");
    }
  };

  return ReactDOM.createPortal(
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        
        {/* Header */}
        <div className="modal-header-section">
          <button className="back-arrow" onClick={onClose}>
            ←
          </button>
          <div className="header-text">
            <h4>Jashn-E-Holi 4.0 - Pune 2026</h4>
            <p>Le Stone: Pune | Tue 03 Mar | 09:30 AM</p>
          </div>
        </div>

        {/* Body */}
        <div className="modal-body-section">
          <div className="selection-header">
            <strong>Select Tickets</strong>
            <span>Add up to 10 tickets only</span>
          </div>

          <div className="ticket-list">
            {ticketData.map((ticket) => (
              <div className="ticket-item" key={ticket.id}>
                
                <div className="ticket-details">
                  <span className="ticket-name">{ticket.label}</span>
                  <span className="ticket-price">
                    ₹{ticket.price.toLocaleString()}
                  </span>
                </div>

                {/* Normal Tickets */}
                {!ticket.isCoupon && (
                  <a
                    href={ticket.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="add-ticket-btn"
                  >
                    Book Now
                  </a>
                )}

                {/* Coupon Based Ticket */}
                {ticket.isCoupon && (
                  <>
                    {/* Show Button Only If Not Active */}
                    {activeCouponTicket !== ticket.id && (
                      <button
                        className="add-ticket-btn"
                        onClick={() => {
                          setActiveCouponTicket(ticket.id);
                          setError("");
                        }}
                      >
                        Book Now
                      </button>
                    )}

                    {/* Show Coupon Input */}
                    {activeCouponTicket === ticket.id && (
                      <div style={{ marginTop: "10px", width: "100%" }}>
                        <input
                          type="text"
                          placeholder="Enter Coupon Code"
                          value={couponValue}
                          onChange={(e) => setCouponValue(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "8px",
                            borderRadius: "6px",
                            border: "1px solid #ccc"
                          }}
                        />

                        <button
                          className="add-ticket-btn"
                          style={{ marginTop: "8px" }}
                          onClick={() => handleCouponSubmit(ticket.link)}
                        >
                          Apply
                        </button>

                        {error && (
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {error}
                          </p>
                        )}
                      </div>
                    )}
                  </>
                )}

              </div>
            ))}
          </div>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default TicketModal;